<template>
<div class="title">
  <div class="titleTop">
    2048:

  <span class="subTitle">
    Symbol Typing Trainer
  </span>
    </div>
</div>
</template>

<script>
export default {
  name: "Title"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.titleTop{
  font-size:64px
  
}
.subTitle{
  font-size: 30px;
  vertical-align: middle;
}
</style>
